import React, { useState, useEffect } from 'react';

import './styles.css';

import checkDeviceType from '../../../checkDeviceType';

import convertAge from '../../../functions/convertAge';
import compare from '../../../functions/compare';

import coachServices from '../../../services/academy/coachServices';
import reportServices from '../../../services/reportServices';

import MainView from '../../../components/MainView';
import NavHistory from '../../../components/NavHistory';
import SearchBar from '../../../components/SearchBar';
import { Link, useParams } from 'react-router-dom';
import ListOptions from '../../../components/ListOptions';
import ActivityIndicator from '../../../components/ActivityIndicator';
import CoachesCard from './CoachesCard';
import PopupCoachesReports from './PopupCoachesReports';
import { FaUserPlus, FaPrint } from 'react-icons/fa';
import AdminCard from '../../../components/AdminCard';

export default function Coaches(props) {
    const [deviceType, setDeviceType] = useState(checkDeviceType());
    const [searchText, setSearchText] = useState('');
    // const [filterOption, setFilterOption] = useState(0);
    const [orderOptionInfos, setOrderOptionInfos] = useState([]);
    const [studentsList, setCoachesList] = useState([]);
    const [auxCoachesList, setAuxCoachesList] = useState([]);
    const [countCoaches, setCountCoaches] = useState(0);
    const [popupCoachesReportsVisible, setPopupCoachesReportsVisible] = useState(false);
    const [fetching, setFetching] = useState(true);
    const [activeOption, setActiveOption] = useState(0);

    const [isAdmin, setIsAdmin] = useState(false);

    const {id} = useParams();

    function verifyIsAdmin() {
        setIsAdmin(props.history.location.pathname.includes("admin"));

    }

    useEffect(() => {
        window.addEventListener('resize', () => {
            setDeviceType(checkDeviceType())
        });

        verifyIsAdmin();

        readCoaches();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (studentsList.length > 1)
            orderCoaches(orderOptionInfos[0], orderOptionInfos[1]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderOptionInfos]);

    useEffect(() => {
        setAuxCoachesList(filterCoaches());
    }, [activeOption]);

    async function readCoaches() {
        const response = await coachServices.getCoaches();
        if (response.status === 200) {
            setCoachesList(response.data);
            orderCoaches(orderOptionInfos[0], orderOptionInfos[1], response.data);
        } else
            alert("Erro ao ler professores, tente novamente!");

        setFetching(false);
    };

    function filterCoaches(option = activeOption, array = studentsList) {
        let auxList;
        // eslint-disable-next-line default-case
        switch (option) {
            case 1:
                auxList = array.filter((item) => item.user.ativo === true);
                break;
            case 2:
                auxList = array.filter((item) => item.user.ativo === false);
                break;
            default:
                auxList = array;
                break;
        }
        if (countCoaches !== auxList.length)
            setCountCoaches(auxList.length);
        return auxList;
    }

    function orderCoaches(option, orderOption, array = auxCoachesList, setArray = setAuxCoachesList) {
        let auxList = array.slice();
        switch (option) {
            case 1: // Ordena pela idade
                auxList.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`));
                auxList.sort((a, b) => compare(convertAge(a.data_nascimento), convertAge(b.data_nascimento), orderOption));
                break;
            // case 2: // Ordena pela turma
            //     auxList.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`));
            //     auxList.sort((a, b) => compare(a.turma ? a.turma.nome : null, b.turma ? b.turma.nome : null, orderOption));
            //     break;
            default: // Ordena pelo nome
                auxList.sort((a, b) => compare(`${a.nome} ${a.sobrenome}`, `${b.nome} ${b.sobrenome}`, orderOption));
        }

        if (countCoaches !== auxList.length)
            setCountCoaches(auxList.length);

        setArray(auxList);
    }

    function searchCoach(searchName, array = studentsList) {
        let auxList = array.filter((item) => `${item.nome} ${item.sobrenome}`.toLowerCase().includes(searchName.toLowerCase()) || item.id.toString() === searchName);
        orderCoaches(orderOptionInfos[0], orderOptionInfos[1], auxList);
    }

    function deleteItemFromList(index, array = studentsList, setArray = setCoachesList) {
        setArray([...array.slice(0, index), ...array.slice(index + 1, array.length)]);
    }

    function onDeleteCoach(index) {
        const indexOf = studentsList.indexOf(auxCoachesList[index]);
        deleteItemFromList(index, auxCoachesList, setAuxCoachesList);
        deleteItemFromList(indexOf);
    }

    async function deleteCoach(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja apagar o(a) professor(a) ${nome}?`)) {
            const response = await coachServices.deleteCoach(id);
            if (response.status === 204) {
                onDeleteCoach(index);
                setCountCoaches(auxCoachesList.length);
                console.log(`Professor ${nome} apagado!`);
            } else
                alert("Erro ao apagar professor, tente novamente!");
        }
    }

    async function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            await reportServices.generateReportCoaches(auxCoachesList, `RELATÓRIO DE PROFESSORES DA ACADEMIA`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    function onDisableCoach(index) {
        const indexOf = studentsList.indexOf(auxCoachesList[index]);

        setCoachesList(originalArray => {
            let temp = [...originalArray];
            temp[indexOf].user.ativo = false;
            return temp;
        });
    }

    function onActivateCoach(index) {
        const indexOf = studentsList.indexOf(auxCoachesList[index]);

        setCoachesList(originalArray => {
            let temp = [...originalArray];
            temp[indexOf].user.ativo = true;
            return temp;
        });
    }

    async function disableCoach(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja desativar o professor ${nome}?`)) {
            const response = await coachServices.disableCoach(id);
            if (response.status === 200) {
                onDisableCoach(index);
                console.log(`Professor ${nome} desativado!`);
            } else
                alert("Erro ao arquivar o professor, tente novamente!");
        }
    }

    async function activateCoach(index, id, nome) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(`Deseja ativar o professor ${nome}?`)) {
            const response = await coachServices.activateCoach(id);
            if (response.status === 200) {
                onActivateCoach(index);
                console.log(`Professor ${nome} ativado!`);
            } else
                alert("Erro ao ativar o professor, tente novamente!");
        }
    }

    return (
        <MainView currentPage={isAdmin ? "academies" : 'coaches'} adminMenu={isAdmin}>
            <NavHistory navPages={["Professores"]} />

            <div className='coaches-page-options'>
                <SearchBar
                    placeholder={deviceType === 'phone' ? "Nome ou ID do professor" : "Digite o nome ou o ID do professor"}
                    onChange={(event) => {
                        setSearchText(event.target.value);
                        if (event.target.value === "")
                            orderCoaches(orderOptionInfos[0], orderOptionInfos[1], studentsList);
                    }}
                    value={searchText}
                    onClick={() => searchCoach(searchText)}
                />

                <div className='coaches-page-options-buttons'>
                    <Link to={ isAdmin ? `/admin/academias/${id}/professores/cadastro` : '/academia/professores/cadastro'} className='button new-coach'>
                        {/* {deviceType === 'phone' ? <FaUserPlus /> : <>Novo professor<FaUserPlus /></>} */}
                        Novo professor<FaUserPlus />
                    </Link>

                    <button title="Gerar relatório" onClick={() => setPopupCoachesReportsVisible(true)}><FaPrint /></button>
                    <PopupCoachesReports
                        visibility={popupCoachesReportsVisible}
                        setVisibility={setPopupCoachesReportsVisible}
                        generateReport={generateReport}
                    />
                </div>
            </div>

            <div className='coaches-page-list-infos'>
                <span>Exibindo {countCoaches} {countCoaches === 1 ? "professor" : "professores"}</span>
                <div className='coaches-page-list-options'>
                    {/* <ListOptions
                        title='Filtrar'
                        options={["Todos", "Pagos", "Não pagos"]}
                        setOptionInfos={setFilterOption}
                        optionInfos={filterOption}
                    /> */}
                    <ListOptions
                        title='Status'
                        options={["Todos", "Ativos", "Inativos"]}
                        setOptionInfos={setActiveOption}
                        optionInfos={activeOption}
                    />
                    <ListOptions
                        title='Ordenar'
                        options={["Nome", "Idade"]}
                        isToOrder
                        setOptionInfos={setOrderOptionInfos}
                    />
                </div>
            </div>

            {
                !fetching ?
                    <ul className='coaches-page-list'>
                        {
                            auxCoachesList && auxCoachesList.length !== 0 ?
                                auxCoachesList.map((item, index) =>
                                    {
                                        return isAdmin ?
                                        <AdminCard
                                            obj={item}
                                            foto={item.foto}
                                            nome={item. nome + " "+ item.sobrenome}
                                            key={index}
                                            onActivate={() => activateCoach(index, item.id, item.nome)}
                                            onDisable={() => disableCoach(index, item.id, item.nome)}
                                            active={item.user.ativo}
                                            little={deviceType === 'phone'}
                                            linkInfo={`/admin/academias/${id}/professores/${item.id}`}
                                            onEditPassword={coachServices.patchCoachPassword}

                                        />
                                        :
                                        <CoachesCard
                                            key={item.id}
                                            id={item.id}
                                            src={item.foto}
                                            name={`${item.nome} ${item.sobrenome}`}
                                            age={convertAge(item.data_nascimento)}
                                            little={deviceType === 'phone' ? true : false}
                                            medium={deviceType === 'tablet' ? true : false}
                                            onActivate={() => activateCoach(index, item.id, item.nome)}
                                            onDisable={() => disableCoach(index, item.id, item.nome)}
                                            active={item.user.ativo}
                                            onDelete={() => deleteCoach(index, item.id, item.nome)}


                                            isAdmin={isAdmin}
                                            academyId={id}
                                        />
                                    }
                                )
                                : []
                        }
                    </ul>
                    : <ActivityIndicator />
            }
        </MainView>
    )
}